import clsx from 'clsx';
import React from 'react';
import useView from 'src/hooks/useView';
import * as types from 'src/types';
import { getStrapiImageSource } from 'src/utils/strapiDataHelpers';
import CTAButton from '../CTAButton/CTAButton';

import * as styles from './HBOPagePromo.module.scss';

type Props = {
  id: string;
  text?: types.TextFields;
  button?: types.ButtonFields;
  backgroundImage?: types.ImageFields;
  graphic?: types.ImageFields;
};

export const HBOPagePromo = ({
  id,
  text,
  button,
  backgroundImage,
  graphic,
}: Props) => {
  const view = useView();

  return (
    <section id={`hbo-page-promo-${id}`} className={clsx(styles.section)}>
      {backgroundImage && (
        <picture>
          {backgroundImage.src.lg ? (
            <>
              {backgroundImage.src.sm ? (
                <source
                  media="(min-width: 768px)"
                  srcSet={backgroundImage.src.lg.url}
                />
              ) : (
                <></>
              )}
              <img
                className={clsx(styles.backgroundImage)}
                src={backgroundImage.src.sm?.url ?? backgroundImage.src.lg.url}
                alt=""
              />
            </>
          ) : (
            <></>
          )}
        </picture>
      )}
      <div className={clsx(styles.container)}>
        {graphic && (
          <picture>
            {graphic.src.lg ? (
              <>
                {graphic.src.sm ? (
                  <source
                    media="(min-width: 768px)"
                    srcSet={graphic.src.lg.url}
                  />
                ) : (
                  <></>
                )}
                <img
                  className={clsx(styles.graphic)}
                  src={graphic.src.sm?.url ?? graphic.src.lg.url}
                  alt=""
                />
              </>
            ) : (
              <></>
            )}
          </picture>
        )}
        {text?.text && (
          <p
            className={clsx(styles.text)}
            dangerouslySetInnerHTML={{
              __html: text.text,
            }}
          />
        )}

        {button && (
          <CTAButton
            data={{
              button: {
                ...button,
                icon:
                  button.type === types.ButtonTypes.overlay
                    ? ['far', 'play-circle']
                    : undefined,
              },
            }}
          />
        )}
      </div>
    </section>
  );
};
